import { environmentForFrame, type BeachFrame } from './model';
import { forecastIsStale } from '../../conditions/forecast-presentation';
import type { BeachPackage } from '../types';
export type ScoreCurves = Record<string, readonly { hour: number; score: number | null; isDay: boolean }[]>;
export type ScoreFreshness = Record<string, { lastUpdated: string | null | undefined; isStale?: boolean }>;
/** Match the page's per-sport freshness policy across its whole scored date window. */
export function qualifiedScoreDates(dates: Record<string, ScoreCurves>, freshness: ScoreFreshness, now = Date.now()): Record<string, ScoreCurves> {
  return Object.fromEntries(Object.entries(dates).map(([date, curves]) => [date,
    Object.fromEntries(Object.entries(curves).map(([sport, curve]) => [sport,
      forecastIsStale(freshness[sport]?.lastUpdated, freshness[sport]?.isStale, now) ? [] : curve,
    ])),
  ]));
}
/** Only describe a forecast tide when the canvas can place that exact tide. */
export function tidePresentation(frame: BeachFrame | null, pack: BeachPackage | null) {
  const water = pack ? environmentForFrame(frame, pack.gridToTrueNorthRad, pack.tideCalibration).waterLevelOdnM : null;
  if (water === null || !pack?.tideCalibration || !frame?.tide) return {label: 'Reference water level', detail: 'Tide unavailable'};
  return {label: 'Regional tide estimate', detail: `${(water - pack.tideCalibration.chartDatumOdnM).toFixed(1)} m · ${frame.tide.state}`};
}
